import { useCallback, useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { StatusCards } from "@/components/settings/backup/StatusCards";
import { HistoryTable } from "@/components/settings/backup/HistoryTable";
import { RestoreTestCard } from "@/components/settings/backup/RestoreTestCard";
import { S3ImportCard } from "@/components/settings/backup/S3ImportCard";
import { SystemModeCard } from "@/components/settings/backup/SystemModeCard";
import { SettingsCard } from "@/components/settings/backup/SettingsCard";
import { VersionCard } from "@/components/settings/backup/VersionCard";
import { WeeklyReportsCard } from "@/components/settings/backup/WeeklyReportsCard";
import { ErrorReportsCard } from "@/components/settings/backup/ErrorReportsCard";
import { UsageReportCard } from "@/components/settings/backup/UsageReportCard";

export default function BackupPanel() {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  const load = useCallback(() => api.get("/backup/overview").then(({ data }) => setD(data)).catch((e) => setErr(apiError(e))), []);
  useEffect(() => { load(); }, [load]);
  if (err) return <div className="panel p-4 text-rose-700 text-sm" data-testid="backup-error">{err}</div>;
  if (!d) return <div className="panel h-40 animate-pulse" />;
  return (
    <div className="space-y-4" data-testid="backup-panel">
      <SystemModeCard />
      {(user?.is_super || user?.role_key === "yonetici") && <UsageReportCard />}
      {user?.is_super && <ErrorReportsCard />}
      <StatusCards d={d} onDone={load} />
      <HistoryTable d={d} onDone={load} />
      <div className="grid lg:grid-cols-2 gap-4">
        <RestoreTestCard d={d} onDone={load} />
        {user?.is_super && d.s3?.configured && <S3ImportCard onDone={load} />}
        <SettingsCard d={d} onDone={load} />
      </div>
      <WeeklyReportsCard d={d} onDone={load} />
      <VersionCard isSuper={d.is_super} />
    </div>
  );
}
